import React, { Component } from "react";
import "./style.scss";

export default class SocialFeed extends Component {
  render() {
    return <></>;
  }
}
